export const PROJECT_NAME = 'SHELL';

export const PageRoutes = new Map([
  [
    'prestamo-personal',
    {
      route: 'prestamo-personal',
    },
  ],
  [
    'abrir-cuenta',
    {
      route: 'abrir-cuenta',
    },
  ],
  [
    'plazo-fijo',
    {
      route: 'plazo-fijo',
    },
  ],
  [
    'registro-usuario',
    {
      route: 'registro-usuario',
    },
  ],
  [
    'inicio',
    {
      route: 'inicio',
    },
  ],
]);
